import apiChange from '../apiChange';
import { ParamsBodyChangeSolicitation } from 'utils/typeServices';

export const PostCancelChangeOwnerSolicitation = async ({ body }: { body: ParamsBodyChangeSolicitation }) => {
    const bodyJson = JSON.stringify(body);
    const token = localStorage.getItem('token');

    try {
        const { data } = await apiChange.post<{ data: any }>('/changeowner/cancelChangeSolicitation/v1', bodyJson, {
            headers: {
                'Authorization': 'Bearer ' + token,
            }
        });

        return data;
    } catch (error) {
        return null;
    }
}
